import { DpdProductVariant } from "../dpd-product/dpd-product-variant"
import * as _ from "lodash"

export class CreateParcelModelOption {
  readonly name: string
  enabled: boolean = false
  _value: boolean = false
  visible: boolean

  toDisableExpression!: string
  valueWhenDisabledExpression?: string

  private readonly createParcelModelOptions: any

  constructor(createParcelModelOptions: any, name: string, visible: boolean = true) {
    this.createParcelModelOptions = createParcelModelOptions
    this.name = name
    this.visible = visible
  }

  initFrom(dpdProductVariant: DpdProductVariant) {
    const dpdVariantOption: string = dpdProductVariant[this.name]
    if (dpdVariantOption === "OPTIONAL") {
      this.enabled = true
    }
    if (dpdVariantOption === "MANDATORY") {
      this.enabled = false
      this._value = true
    }
    if (dpdVariantOption === "DISABLED") {
      this.enabled = false
      this._value = false
    }
  }

  // contextChanged() {
  //   const toDisable = this.createParcelModelOptions.evaluateExpression<boolean>(this.toDisableExpression)
  //   this.enabled = !toDisable
  //   if (toDisable) {
  //     this._value = _.isNil(this.valueWhenDisabledExpression)
  //       ? true
  //       : this.createParcelModelOptions.evaluateExpression(this.valueWhenDisabledExpression)
  //   }
  // }

  get value(): boolean {
    return this._value
  }

  set value(value: boolean) {
    this._value = value
    // this.createParcelModelOptions.handleProductOptionsWithExpressions()
  }
}
